<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #FFFFFF; height: 100vh;">
        <v-toolbar dense :color="'#FF9C00'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo2.png" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-row v-if="!pagoRealizado">
            <v-col class="text-center">
                <h1 class="ma-4">Completa los datos de los peregrinos para confirmar tu reserva</h1>
            </v-col>
        </v-row>

        <v-row v-if="!pagoRealizado">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    Para gestionar tu reserva, necesitamos los datos completos de todos los peregrinos que realizarán el
                    Camino de Santiago. Por favor, rellena cada formulario con la información solicitada.
                    <br>
                    Es importante que los datos sean precisos y estén completos, ya que los utilizaremos para la
                    organización del viaje, la reserva de alojamientos y otros servicios.
                    <br>
                    Una vez hayas completado toda la información, procederemos a confirmar tu reserva. Si tienes alguna
                    duda, no dudes en contactarnos.
                </p>
            </v-col>
        </v-row>

        <v-row v-if="pagoRealizado">
            <v-col class="text-center">
                <h1 class="ma-4">Pago realizado correctamente</h1>
            </v-col>
        </v-row>

        <v-row v-if="pagoRealizado">
            <v-col class="text-center">
                <p style="font-size: 1.2rem;" class="mx-16">
                    Gracias por confiar en nosotros.
                    <br>
                    Nos pondremos en contacto contigo para confirmar los detalles de tu reserva.
                    <br>
                </p>
            </v-col>
        </v-row>

        <v-container v-if="reserva">
            <v-row>
                <v-col v-for="index in reserva.cant_peregrinos" :key="index" cols="12" md="4">
                    <v-card>
                        <v-card-title>
                            Datos del Peregrino {{ index }}
                        </v-card-title>
                        <v-card-text>
                            <v-row dense class="mx-4">
                                <v-text-field :disabled="estado == 'pago'" v-model="pasajeros[index - 1].nombre"
                                    outlined label="Nombre" dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                                <v-text-field :disabled="estado == 'pago'" v-model="pasajeros[index - 1].apellidos"
                                    outlined label="Apellidos" dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                                <v-text-field :disabled="estado == 'pago'" v-model="pasajeros[index - 1].dni" outlined
                                    label="DNI/NIE" dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                                <v-text-field :disabled="estado == 'pago'" v-model="pasajeros[index - 1].edadNacimiento"
                                    outlined label="Fecha de Nacimiento (dd/mm/aaaa)" dense
                                    autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                                <v-text-field :disabled="estado == 'pago'" v-model="pasajeros[index - 1].direccion"
                                    outlined label="Dirección" dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                                <v-text-field :disabled="estado == 'pago'" v-model="pasajeros[index - 1].poblacion"
                                    outlined label="Población" dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                                <v-text-field :disabled="estado == 'pago'" v-model="pasajeros[index - 1].provincia"
                                    outlined label="Provincia" dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                                <v-text-field :disabled="estado == 'pago'" v-model="pasajeros[index - 1].cp" outlined
                                    label="CP" dense autocomplete="off"></v-text-field>
                            </v-row>

                            <v-row dense class="mx-4">
                                <v-select :disabled="estado == 'pago'" v-model="pasajeros[index - 1].nacionalidad"
                                    :items="nacionalidades" outlined label="Nacionalidad" dense
                                    autocomplete="off"></v-select>
                            </v-row>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="estado == 'pago'">
                <v-col align="end">
                    <p>
                        Sus datos han sido enviados correctamente. Ya puede efectuar el pago de la reserva.
                        <br>
                        Le informamos que el importe de la reserva es de {{ formatearImporte(reserva.importe_presupuestado) }}.
                        <br>
                        Su banco puede cobrar comisiones por el pago en caso de ...
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col align="end">
                    <v-btn class="mt-4" :disabled="!pasajerosCompletos || estado == 'pago'"
                        style="background-color: #FF9C00; color: black;" @click="_confirmarPasajeros">
                        CONFIRMAR DATOS
                    </v-btn>
                    <v-btn v-if="estado == 'pago'" class="mt-4 ml-4" style="background-color: #FF9C00; color: black;"
                        @click="_Pagar">
                        PAGAR
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { formatearImporte } from '@/helpers/reservaHelpers';

export default {
    data() {
        return {
            comentario: '',
            reserva: null,
            pasajeros: [],
            estado: 'confirmacion',
            pagoRealizado: false,
            data: "eyJEc19BbW91bnQiOiIxNTM1MDAiLCJEc19DdXJyZW5jeSI6Ijk3OCIsIkRzX09yZGVyIjoiZVRNQ2xvIiwiRHNfTWVyY2hhbnRDb2RlIjoiMjYzMTAwMDAwIiwiRHNfVGVybWluYWwiOiI2MSIsIkRzX1Jlc3BvbnNlIjoiOTk5OCIsIkRzX0F1dGhvcmlzYXRpb25Db2RlIjoiIiwiRHNfVHJhbnNhY3Rpb25UeXBlIjoiRiIsIkRzX1NlY3VyZVBheW1lbnQiOiIwIiwiRHNfTGFuZ3VhZ2UiOiIxIiwiRHNfTWVyY2hhbnREYXRhIjoiIiwiRHNfVXJsUGFnbzJGYXNlcyI6Imh0dHBzOi8vc2lzLXQucmVkc3lzLmVzOjI1NDQzL3Npcy9wMmY_dD0yODNGQjE4QzkyQ0E1NTk0OTk3NDM0RUREM0Y5RkYwMzgwQ0E0Q0ExIiwiRHNfQ29udHJvbF8xNzM5OTc0NDMxMjc0IjoiMTczOTk3NDQzMTI3NCJ9",
        };
    },
    computed: {
        ...mapState(["nacionalidades"]),

        pasajerosCompletos() {
            return this.pasajeros.every(pasajero => {
                return pasajero.nombre; // && pasajero.nacionalidad;
            });
        }
    },
    mounted() {
        this.estado = 'confirmacion';
        const hash = this.$route.params.hash;
        this.logout();
        if (hash != 'pagoRealizado') {
            this._getReservaByHash(hash);
        } else {
            this.pagoRealizado = true;
        }
    },
    methods: {
        ...mapMutations("auth", ["logout"]),
        ...mapActions("reservas", ["getReservaByHash", "confirmarPasajeros", "obtenerUrlPago"]),
        formatearImporte,


        async _getReservaByHash(hash) {
            this.reserva = await this.getReservaByHash([hash]);
            this.pasajeros = Array.from({ length: this.reserva.cant_peregrinos }, (_, index) => ({
                nombre: '',
                apellidos: '',
                dni: '',
                edadNacimiento: '',
                direccion: '',
                poblacion: '',
                provincia: '',
                nacionalidad: '',
                cp: '',
                ...(this.reserva.pasajeros?.[index] || {}),
            }));
        },

        async _confirmarPasajeros() {
            var res = await this.confirmarPasajeros([this.pasajeros, this.reserva.id, this.reserva.version_pasajeros]);
            if (res) {
                this.estado = 'pago';
            }
        },

        async _Pagar() {
            var res = await this.obtenerUrlPago([this.reserva.id]);
            if (res && res.payment_url) {
                let buff = Buffer.from(res.payment_url, 'base64');
                let text = buff.toString('ascii');
                let decodedData = JSON.parse(text);
                let campo = decodedData.Ds_UrlPago2Fases;
                if (campo.startsWith('https')) {
                    window.open(campo, '_blank');
                }
            }



            /* let buff = Buffer.from(this.data, 'base64');
               let text = buff.toString('ascii');
               let decodedData = JSON.parse(text);
               let campo = decodedData.Ds_UrlPago2Fases;
               if (campo.startsWith('https')) {
                   window.open(campo, '_blank');
               }
               */
        }
    },
};
</script>

<style scoped></style>
